/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { Flex } from '@getgo/chameleon-chakra-ui';
import React from 'react';
import { GoToJoinHeading } from '../../Components/Heading/GoToJoinHeading';
import { NativeJoinButton } from '../../Components/Buttons/NativeJoinButton';
import { WebJoinButton } from '../../Components/Buttons/WebJoinButton';
import { Divider } from '../../../../Divider/Divider';
import { colors } from '@getgo/chameleon-core';
import { Spacing } from '../../../../../themes/GoToTheme';
import { TelemetryState } from '../../../../../hooks/useSendTelemetry';
import { FirstJoinPageProps } from './GoToFirstJoin';

export const GoToFirstJoinNative: React.FC<FirstJoinPageProps> = ({
  onStartButtonClick,
}) => {
  return (
    <>
      <GoToJoinHeading greeting />
      <Flex minWidth='min-content'>
        <WebJoinButton telemetryState={TelemetryState.First} />
        <Divider marginX={Spacing.CoreLayout2} color={colors.neutrals.n300} />
        <NativeJoinButton
          caption
          firstJoin
          secondaryButton
          onStartButtonClick={onStartButtonClick}
        />
      </Flex>
    </>
  );
};
